<template>
  <div class="confirm-order-container">
    <!-- 页面标题 -->
      <div class="page-header">
        <h3 class="title">{{ pageTitle }}</h3>
        <el-button type="plain" @click="handleCancel" class="back-button">
          <i class="el-icon-arrow-left"></i> {{ t('settlement.back') }}
        </el-button>
      </div>
    <div class="confirm-order-page">
      <div class="face-auth-container">
        <el-alert
          v-if="faceAuthStatus !== 'passed'"
          type="warning"
          :title="t('settlement.notFaceAuthAlertTip')"
          show-icon
          :closable="false"
        />
        <div v-if="faceAuthStatus !== 'passed'" @click="showFaceVerification" class="verify-now-button">
         {{ t('settlement.proceed') }} &gt;
        </div>
      </div>
      
      <!-- 退回原因提示（编辑模式） -->
      <el-alert
        v-if="isEditMode && settlementRemark"
        :title="`${t('settlement.returned')}：${settlementRemark}`"
        type="error"
        show-icon
        :closable="false"
        style="margin-bottom: 20px;"
      />
      
      
      <div class="page-content">
        <el-form label-position="left" label-width="160px">
          <!-- 账单周期 -->
          <el-form-item :label="t('settlement.billCycle')">
            <span>{{ currentMonth || '-' }}</span>
          </el-form-item>
          
          <!-- 账单金额 -->
          <el-form-item :label="t('settlement.billAmount')">
            <span>{{ $filters.currency(commissionAmount, '', '', 'amount') || '-' }} {{ settlementCcy }}</span>
            <el-tag v-if="dict.settlementStatus && dict.settlementStatus.mappings && settlementStatus && (dict.settlementStatus.mappings[settlementStatus] || dict.settlementStatus.mappings[Number(settlementStatus)])" :type="(dict.settlementStatus.mappings[settlementStatus] || dict.settlementStatus.mappings[Number(settlementStatus)]).tagType" style="margin-left: 10px;">
              {{ (dict.settlementStatus.mappings[settlementStatus] || dict.settlementStatus.mappings[Number(settlementStatus)]).label }}
            </el-tag>
            <span v-else-if="settlementStatus" style="margin-left: 10px; color: #909399;">-</span>
          </el-form-item>
          <!-- TPV -->
           <el-form-item label="TPV">
            <span>{{ $filters.currency(tpvAmt, '', '', 'amount') || '-' }}</span>
          </el-form-item>
          <!-- 收款账号 -->
          <el-form-item :label="t('settlement.bankAccount')" required>
            <div class="account-section">
              <el-select v-model="selectedAccount" :placeholder="t('settlement.selectBankAccount')" style="width: 500px;" :disabled="isViewMode" @change="handleAccountChange">
               <el-option  value="add" :label="+t('settlement.addBankAccount')" v-if="!isViewMode && accounts.length < 1">
                <span style="color: #409EFF;">+{{ t('settlement.addBankAccount') }}</span>
              </el-option>
                <el-option
                v-for="account in accounts"
                :key="account.id"
                :label="`${account.bankAcctName}-${account.bankName}${account.bankAcctNo}`"
                :value="account.id"
              >
                <span>{{ account.bankAcctName }}-{{ account.bankName }}{{ account.bankAcctNo }}</span>
                <el-tag v-if="account.id === latestBankId" size="small" type="warning" effect="plain" style="margin-left: 10px;">{{ t('settlement.lastUsed') }}</el-tag>
              </el-option>
             
            </el-select>
            </div>
          </el-form-item>
          <!-- 上传发票 -->
        <el-form-item :label="t('settlement.invoice')">
          <div class="upload-section">
            <!-- 上传按钮 -->
            <el-upload
              v-if="!isViewMode"
              ref="uploadRef"
              class="upload-button"
              action="#"
              :auto-upload="false"
              :on-change="handleFileChange"
              :show-file-list="false"
              :limit="1"
              :multiple="false"
              accept=".pdf,.jpg,.jpeg,.png"
            >
              <el-button type="primary" :loading="uploadLoading">
                <el-icon class="el-icon--right"><Upload /></el-icon> {{ t('settlement.uploadFile') }}
              </el-button>
            </el-upload>
            
            <!-- 上传统计 -->
            <div class="upload-stats" v-if="invoices.length > 0">
              <span>{{ t('settlement.totalUploadedInvoices') }}: <span class="stats-number">{{ fileCount }}</span></span>
              <span>{{ t('settlement.invoiceTotal') }}: ¥<span class="stats-number">{{ $filters.currency(invoiceTotal, '', '', 'amount') }}</span></span>
            </div>
            
            <!-- 发票列表 -->
            <div class="invoice-list">
              <!-- 空状态 -->
              <div v-if="invoices.length === 0" class="empty-state">
                <img src="@/assets/img/dashboard/empty.png" alt="暂无发票" class="empty-image" />
                <p class="empty-text">{{ t('settlement.noInvoiceTip') }}</p>
              </div>
              
              <!-- 发票列表 -->
              <div 
                v-else
                v-for="(invoice, index) in invoices" 
                :key="index"
                class="invoice-item"
              >
                <!-- 发票缩略图 -->
                <div class="invoice-thumbnail">
                  <img
                    :src="invoice.name ?  require('@/assets/img/invoice-s.png') : require('@/assets/img/not-invoice-s.png')"
                    alt="发票缩略图"
                    class="invoice-image"
                    @click="handleInvoiceImageClick(invoice.fileId || invoice.id)"
                  />
                </div>
                
                <!-- 发票信息 -->
                <div class="invoice-info">
                  <div class="invoice-header">
                    <div class="invoice-header-left"> 
                      <h4 class="invoice-name">{{ invoice.name || t('settlement.unknownFile') }}</h4>
                      <div class="invoice-status">
                        <el-tag v-if="dict.checkStatus && dict.checkStatus.mappings && invoice.checkStatus" :type="dict.checkStatus.mappings[invoice.checkStatus].tagType" size="small">
                          {{ dict.checkStatus.mappings[invoice.checkStatus].label }}
                        </el-tag>
                        <el-tag v-else :type="'default'" size="small">
                          {{ invoice.checkStatus }}
                        </el-tag>
                      </div>
                    </div>
                    <!-- 删除按钮 -->
                    <div class="invoice-actions" v-if="!isViewMode">
                      <el-button 
                        type="text" 
                        @click="removeInvoice(index, invoice)"
                        class="delete-button"
                      >
                        <el-icon><Delete/></el-icon>
                      </el-button>
                    </div>
                  </div>
                  <div class="invoice-details">
                    <p v-if="invoice.errorMessage" class="error-message">{{ invoice.errorMessage }}</p>
                    <div class="invoice-amounts">
                      <span>
                        <span class="label">{{ t('settlement.totalPrice') }}</span>
                        <span class="value" v-if="invoice.totalAmount">¥{{ $filters.currency(invoice.totalAmount, '', '', 'amount') }}</span>
                        <span v-else>-</span>
                      </span>
                      <span>
                        <span class="label">{{ t('settlement.deductibleAmount') }}</span>
                        <span class="value" v-if="invoice.deductibleAmount">¥{{ $filters.currency(invoice.deductibleAmount, '', '', 'amount') }}</span>
                        <span v-else>-</span>
                      </span>
                    </div>
                    
                    <!-- 展开/收起按钮 -->
                    <div class="invoice-toggle" v-if="invoice.name"> 
                      <el-button 
                        type="text" 
                        @click="toggleInvoiceExpand(index)"
                      >
                        <!-- <i :class="invoice.expanded ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i> -->
                        {{ invoice.expanded ? t('settlement.collapseDetail') : t('settlement.expandDetail') }}
                      </el-button>
                    </div>
                    <!-- 详细信息（展开时显示） -->
                    <div v-if="invoice.expanded" class="invoice-detail-info">
                      <div class="detail-row">
                        <div class="detail-item">
                          <span class="detail-label">{{ t('settlement.invoiceNumber') }}：</span>
                          <span class="detail-value">{{ invoice.details.invoiceNumber || '-' }}</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">{{ t('settlement.invoiceDate') }}：</span>   
                          <span class="detail-value">{{ invoice.details.issueDate || '-' }}</span>
                        </div>
                      </div>
                      <div class="detail-row">
                        <div class="detail-item">
                          <span class="detail-label">{{ t('settlement.invoiceDrawer') }}：</span>
                          <span class="detail-value">{{ invoice.details.issuer || '-' }}</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">{{ t('settlement.title') }}：</span>
                          <span class="detail-value">{{ invoice.details.title || '-' }}</span>
                        </div>
                      </div>
                      <div class="detail-row">
                        <div class="detail-item">
                          <span class="detail-label">{{ t('settlement.sellerName') }}：</span>
                          <span class="detail-value">{{ invoice.details.sellerName || '-' }}</span>
                        </div>
                      </div>
                      <div class="detail-row">
                        <div class="detail-item">
                          <span class="detail-label">{{ t('settlement.sellerTaxNumber') }}：</span>
                          <span class="detail-value">{{ invoice.details.sellerTaxId || '-' }}</span>
                        </div>
                      </div>
                      <div class="detail-row">
                        <div class="detail-item">
                          <span class="detail-label">{{ t('settlement.purchaseName') }}：</span>
                          <span class="detail-value">{{ invoice.details.buyerName || '-' }}</span>
                        </div>
                      </div>
                      <div class="detail-row">
                        <div class="detail-item">
                          <span class="detail-label">{{ t('settlement.purchaseTaxNumber') }}：</span>
                          <span class="detail-value">{{ invoice.details.buyerTaxId || '-' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
              
              </div>
            </div>
            
            <!-- <p class="upload-tip">请按要求说明上传图片，以防被驳回</p> -->
          </div>
        </el-form-item>
          
          
        </el-form>
      </div>
      
      <div class="page-footer" v-if="!isViewMode">
        <el-button @click="handleCancel">{{ t('commonBtn.btn.cancel')}}</el-button>
        <el-button type="primary" @click="confirmBill">{{ t('settlement.confirmBill') }}</el-button>
      </div>
    </div>
  </div>
  
  <!-- 人脸认证弹框 -->
  <face-verification-dialog
    v-model:visible="faceVerificationVisible"
    @verify-complete="handleVerificationComplete"
  />
</template>

<script>
import { ref, reactive, toRefs, computed, onMounted } from "vue";
import { useI18n } from "@/plugins/i18n";
import { useRoute, useRouter } from 'vue-router';
import { dataUtils } from "@libs/utils";
import { vab } from "@libs/utils";
import { FILE } from '@/domain/base';
import SrUploadPlus from '@/components/sr-upload-plus';
import FaceVerificationDialog from '@/components/FaceVerificationDialog';
import { modifyInvoiceInfo,uploadInvoice,billConfirm, getCurrentSettlementInfo, listInvoiceInfo, faceVerification } from '@/api/modules/settlement';
import { getBankAcct } from "@/api/modules/auth";
import { getFilePath } from '@/api/modules/common';
import common from '@/compositions/modules/common';
import fileComp from '@/compositions/modules/file';
import { useStore } from 'vuex';
export default {
  name: 'ConfirmOrder',
  components: {
    SrUploadPlus,
    FaceVerificationDialog
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const { dict } = common();
    const { getFileType, fileToBase64, getFileRemoteInfo } = fileComp();
    const uploadRef = ref(null);
    const store = useStore();
    // 获取registerInfo
    const registerInfo = computed(() => store.state.auth.registerInfo);
    console.log(registerInfo.value,'registerInfo.value333333333');
    const scopedStates = reactive({
      regType: registerInfo.value.regType,
      commissionAmount: 0,
      settlementCcy: '',
      tpvAmt: 0, // TPV金额
      currentMonth: '',
      settlementRemark: '',
      selectedAccount: '', // 选中的收款账户
      accounts: [], // 收款账户列表
      fileCount: 0, // 上传文件数量
      invoiceTotal: 0, // 发票总额
      uploadLoading: false, // 上传loading状态
      invoices: [],
      settlementInfo: null, // 结算信息
      loading: false, // 加载状态
      month: '', // 月份参数
      faceAuthStatus: route.query.faceAuthStatus || '', // 人脸认证状态
      faceVerificationVisible: false, // 人脸认证弹框可见性
      latestBankId: '', // 最近使用的银行ID
      settlementStatus: '' // 结算状态
    });
    
    const { t } = useI18n();
    
    // 计算当前是否为查看模式
    const isViewMode = computed(() => {
      return route.query.mode === 'view';
    });
    
    // 计算当前是否为编辑模式
    const isEditMode = computed(() => {
      return route.query.mode === 'edit';
    });
    
    // 计算页面标题
    const pageTitle = computed(() => {
      if (isViewMode.value) {
        return t('settlement.settlementDetail');
      }
      return t('settlement.confirmBill');
    });
    
    // 切换发票展开/收起状态
    const toggleInvoiceExpand = (index) => {
      // 先将所有发票的expanded状态设置为false
      scopedStates.invoices.forEach((invoice, i) => {
        if (i !== index) {
          invoice.expanded = false;
        }
      });
      // 然后切换当前点击发票的expanded状态
      scopedStates.invoices[index].expanded = !scopedStates.invoices[index].expanded;
    };
    
    // 显示人脸认证弹框
    const showFaceVerification = () => {
      scopedStates.faceVerificationVisible = true;
    };
    
    // 处理人脸认证完成
    const handleVerificationComplete = () => {
      scopedStates.faceAuthStatus = 'passed';
      vab.baseMessage('人脸认证成功', 'success');
    };
    
    // 获取结算信息
    const fetchSettlementInfo = async () => {
      scopedStates.loading = true;
      try {
        const month = route.query.month || '';
        scopedStates.month = month;
        
        const res = await getCurrentSettlementInfo({
          settlementMonth: month
        });    
        if (res) {
          scopedStates.settlementInfo = res;
          scopedStates.commissionAmount = res.settlementAmt;
          scopedStates.currentMonth = res.monthId;
          scopedStates.settlementCcy = res.settlementCcy;
          scopedStates.settlementRemark = res.settlementRemark || '';
          scopedStates.latestBankId = res.latestBankId; // 保存最近使用的银行ID
          scopedStates.settlementStatus = res.settlementStatus; // 保存结算状态
          scopedStates.tpvAmt = res.tpvAmt; // 保存TPV金额
        }
      } catch (error) {
        console.error('获取结算信息失败:', error);
        vab.baseMessage('获取结算信息失败', 'error');
      } finally {
        scopedStates.loading = false;
      }
    };
    
    // 获取银行账户列表
    const fetchBankAccounts = async () => {
      scopedStates.loading = true;
      try {
        const res = await getBankAcct();
        
        if (res && res.list) {
          scopedStates.accounts = res.list;
          
          // 如果有最近使用的银行ID，默认选中
          if (scopedStates.latestBankId) {
            const latestAccount = res.list.find(account => account.id === scopedStates.latestBankId);
            if (latestAccount) {
              scopedStates.selectedAccount = latestAccount.id;
            } else if (res.list.length > 0) {
              scopedStates.selectedAccount = res.list[0].id;
            }
          } else if (res.list.length > 0) {
            scopedStates.selectedAccount = res.list[0].id;
          }
        }
      } catch (error) {
        console.error('获取银行账户列表失败:', error);
        vab.baseMessage('获取银行账户列表失败', 'error');
      } finally {
        scopedStates.loading = false;
      }
    };
    
    // 获取发票信息
    const fetchInvoiceInfo = async () => {
      scopedStates.loading = true;
      try {
        const month = route.query.month || '';
        // const res = mockRes;
        const res = await listInvoiceInfo({
          settlementMonth: month
        });
        if (res && res.invoiceInfoList) {
          // 转换发票数据格式
          scopedStates.invoices = res.invoiceInfoList.map(invoice => ({
            id: invoice.invoiceId, // 确保设置 id 字段
            invoiceId: invoice.invoiceId, // 同时设置 invoiceId 字段
            fileId: invoice.fileId, // 保存fileId用于获取图片
            name: invoice.sellerName,
            checkStatus: invoice.checkStatus, // 保存原始checkStatus字段用于dict映射
            totalAmount: invoice.totalAmount, // 价格合计
            deductibleAmount: invoice.invoiceTax, // 可抵扣税额
            errorMessage: '',
            imageUrl: 'https://neeko-copilot.bytedance.net/api/text2image?prompt=invoice%20receipt%20document&size=512x512',
            details: {
              invoiceNumber: invoice.invoiceNumber, // 发票号码
              issueDate: invoice.invoiceDate, // 发票日期
              issuer: invoice.drawer, // 开票人
              title: invoice.title, // 标题
              sellerName: invoice.sellerName, // 销售方名称
              sellerTaxId: invoice.sellerTaxNumber, // 销售方统一社会信用代码
              buyerName: invoice.purchaserName, // 购买方名称
              buyerTaxId: invoice.purchaserTaxNumber // 购买方统一社会信用代码
            },
            expanded: false
          }));
          
          // 更新统计信息
          scopedStates.fileCount = res.invoiceInfoList.length;
          scopedStates.invoiceTotal = res.invoiceInfoList.reduce((total, invoice) => total + invoice.totalAmount, 0);
        }
      } catch (error) {
        console.error('获取发票信息失败:', error);
        vab.baseMessage('获取发票信息失败', 'error');
      } finally {
        scopedStates.loading = false;
      }
    };
    
    const handleFileChange = async (file) => {
      // 处理文件上传
      try {
        // 检查发票列表数量，最多20张
        if (scopedStates.invoices.length >= 20) {
          vab.baseMessage(t('settlement.maxInvoiceLimit'), 'warning');
          return;
        }
        
        // 检查文件大小，限制为5M
        const maxSize = 5 * 1024 * 1024; // 5MB
        if (file.raw.size > maxSize) {
          vab.baseMessage(t('settlement.invoiceSizeLimit'), 'warning');
          return;
        }
        
        // 设置上传loading状态
        scopedStates.uploadLoading = true;
        
        // 将文件转换为 base64
        const fileBase64 = await fileToBase64(file.raw);
        const base64WithoutPrefix = fileBase64.split(',')[1]; // 移除 data URL 前缀
        
        // 调用上传接口
        await uploadInvoice({
          fileBase64: base64WithoutPrefix,
          monthId: scopedStates.month || scopedStates.currentMonth,
          srcFileName: file.name
        });
        
        // 上传成功后，重新获取发票列表
        await fetchInvoiceInfo();
        
        vab.baseMessage(t('global.content.text_3'), 'success');
      } catch (error) {
        console.error('上传失败:', error);
      } finally {
        // 无论成功失败，都清除上传组件的内部文件列表，确保可以再次上传
        if (uploadRef.value) {
          uploadRef.value.clearFiles();
        }
        // 隐藏loading状态
        scopedStates.uploadLoading = false;
      }
    };
    
    const removefileIdList = () => {
      // 处理文件移除，更新文件数量
      scopedStates.fileCount--;
      scopedStates.invoiceTotal = scopedStates.fileCount * 5000; // 模拟计算
    };
    
    const removeInvoice = async (index, invoice) => {
      try {
        // 调用删除接口
        await modifyInvoiceInfo({
          settlementMonth: scopedStates.month || scopedStates.currentMonth,
          invoiceId: invoice.id || invoice.invoiceId // 确保传递正确的发票ID
        });
        
        // 删除成功后，重新获取发票列表
        await fetchInvoiceInfo();
        
      } catch (error) {
        console.error('删除发票失败:', error);
      }
    };
    
    const handleCancel = () => {
      // 取消，返回上一页
      window.history.back();
    };
    
    const confirmBill = async () => {
      if (scopedStates.faceAuthStatus !== 'passed') {
        // 未通过人脸认证，显示提示
        vab.baseConfirm(
          t('settlement.notFaceAuthAlert'),
          t('settlement.tip'),
          {
            confirmButtonText: t('settlement.proceed'),
            cancelButtonText: t('settlement.skip'),
            type: 'warning',
            showClose: false
          },
          () => {
            // 立即认证逻辑
            showFaceVerification()
          },
          async () => {
            // 暂时跳过，直接提交账单
            await submitBill()
          }
        );
      } else {
        // 人脸认证已通过，直接提交账单
        await submitBill()
      }
    };
    
    // 提交账单
    const submitBill = async () => {
      // 校验收款账号是否选择
      if (!scopedStates.selectedAccount || scopedStates.selectedAccount === 'add') {
        vab.baseMessage(t('settlement.pleaseSelectAccount'), 'error');
        return;
      }
      
      // 校验收款账号状态
      const selectedAccountInfo = scopedStates.accounts.find(account => account.id === scopedStates.selectedAccount);
      // bankAcctCheckStatus=CF，已通过的账户才能确认账单
      if (selectedAccountInfo && selectedAccountInfo.bankAcctCheckStatus !== 'CF') {
        vab.baseMessage(t('settlement.accountUnderReview'), 'error');
        return;
      }
      
      // 校验发票必须上传
      if (scopedStates.regType === '2' && scopedStates.invoices.length === 0) {
        vab.baseMessage(t('settlement.pleaseUploadInvoice'), 'error');
        return;
      }
      
      // 校验发票状态，checkStatus为2-已作废，6-重复，3,4,5-冲红时提示
      const hasInvalidInvoice = scopedStates.invoices.some(invoice => 
        ['2', '3', '4', '5', '6'].includes(invoice.checkStatus)
      );
      
      if (hasInvalidInvoice) {
        vab.baseMessage(t('settlement.pleaseCheck'), 'error');
        return;
      }
      try {
        // 调用确认账单接口
        await billConfirm({
          bankId: scopedStates.selectedAccount,
          monthId: scopedStates.month || scopedStates.currentMonth
        });
        
        // vab.baseMessage("账单确认成功", "success");
        // 确认成功后返回上一页
        window.history.back();
      } catch (error) {
        console.error('确认账单失败:', error);
        // vab.baseMessage('确认账单失败', 'error');
      }
    };
    
    // 处理发票图片点击
    const handleInvoiceImageClick = async (fileId) => {
      try {
        // 调用getFilePath接口获取图片URL
        const res = await getFilePath({ fileId });
        if (res && res.fileUrl) {
          // 打开图片
          window.open(res.fileUrl, '_blank');
        } else {
          vab.baseMessage('FAIL', 'error');
        }
      } catch (error) {
        console.error('获取图片失败:', error);
        // vab.baseMessage('获取图片失败', 'error');
      }
    };
    
    // 处理账户选择
    const handleAccountChange = (value) => {
      if (value === 'add') {
        // 跳转到新增收款账户页面
        router.push('/user/personal');
      }
    };
    
    // 获取人脸认证状态
    const fetchFaceAuthStatus = async () => {
      try {
        const res = await faceVerification();
        scopedStates.faceAuthStatus = res.verifyResult ? 'passed' : 'not_passed';
      } catch (error) {
        console.error('获取人脸认证状态失败:', error);
        // 失败时默认设置为未通过
        scopedStates.faceAuthStatus = 'not_passed';
      }
    };
    
    onMounted(async () => {
      // 页面加载时获取数据
      await fetchSettlementInfo();
      await fetchBankAccounts();
      await fetchInvoiceInfo();
      await fetchFaceAuthStatus();
    });
    
    return {
      t,
      ...toRefs(scopedStates),
      uploadRef,
      registerInfo,
      handleFileChange,
      removefileIdList,
      removeInvoice,
      handleCancel,
      confirmBill,
      submitBill,
      isViewMode,
      isEditMode,
      pageTitle,
      toggleInvoiceExpand,
      fetchSettlementInfo,
      fetchBankAccounts,
      fetchInvoiceInfo,
      showFaceVerification,
      handleVerificationComplete,
      handleInvoiceImageClick,
      handleAccountChange,
      dict
    };
  }
};
</script>

<style lang="scss" scoped rel="stylesheet/scss">
.confirm-order-container {
  padding: 15px 20px;
  background-color: #fff;
  border-radius: 4px 4px 4px 4px;
  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin: 0;
    }
    .back-button {
      color: #606266;
      font-size: 14px;
    }
  }
}

// 人脸认证提示条样式
:deep(.el-alert__content) {
  width: 100%;
}
 
.alert-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .alert-text {
    flex: 1;
    font-size: 13px;
  }
  .verify-now-button {
    color: #409EFF;
    padding: 0;
  }
  :deep(.el-alert__description) {
    margin: 0;
  }
}
.confirm-order-page {
  width: 100%;
  margin: 0 auto;
  
  .face-auth-container {
    margin-bottom: 10px;
    position: relative;
    .verify-now-button {
      position: absolute;
      top: 8px;
      right: 10px;
      font-size: 13px;
      color: #409EFF;
      cursor: pointer;
    }
  }
  .page-content {
    margin-bottom: 10px;
    padding: 20px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    .upload-section {
      // margin-top: 10px;
      // background: #fff;
      // padding: 20px;
      // border-radius: 4px;
      // border: 1px solid #e4e7ed;
      
      .upload-button {
        margin-bottom: 15px;
        
        :deep(.el-upload__input) {
          display: none;
        }
      }
      
      .upload-stats {
        display: flex;
        justify-content: space-between;
        
        span {
          font-size: 14px;
          color: #333333;
          
          .stats-number {
            font-weight: bold;
          }
        }
      }
      
      .invoice-list {
        width: 500px;
        background: #F7F9FB;
        padding: 5px;
        .empty-state {
          background: #F7F9FB;
          padding: 40px 0;
          text-align: center;
          border-radius: 4px;
          
          .empty-image {
            width: 120px;
            margin-bottom: 10px;
          }
          
          .empty-text {
            font-size: 14px;
            color: #909399;
            margin: 0;
          }
        }
        
        .invoice-item {
          display: flex;
          align-items: flex-start;
          padding: 15px;
          margin-bottom: 5px;
          width: 100%;
          background: #FFFFFF;
          border-radius: 6px;
          
          .invoice-thumbnail {
            width: 60px;
            height: 60px;
            border-radius: 4px;
            overflow: hidden;
            margin-right: 15px;
            margin-top: 12px;
            
            .invoice-image {
              width: 100%;
              height: 100%;
              cursor: pointer;
            }
          }
          
          .invoice-info {
            flex: 1;
            
            .invoice-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .invoice-header-left {
                display: flex;
                align-items: center;
                gap: 6px;
              }
              .invoice-name {
                font-size: 14px;
                font-weight: 600;
                color: #303133;
                margin: 0;
                max-width: 200px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              
              .invoice-status {
                display: flex;
                gap: 8px;
                
                .status-tag {
                  font-size: 12px;
                  padding: 2px 8px;
                  border-radius: 10px;
                  
                  &.status-verified {
                    background: #f0f9eb;
                    color: #67c23a;
                  }
                  
                  &.status-unverified {
                    background: #fdf6ec;
                    color: #e6a23c;
                  }
                  
                  &.status-error {
                    background: #fef0f0;
                    color: #f56c6c;
                  }
                }
                
                .usage-tag {
                  font-size: 12px;
                  padding: 2px 8px;
                  border-radius: 10px;
                  
                  &.usage-used {
                    background: #f0f9eb;
                    color: #67c23a;
                  }
                  
                  &.usage-duplicate {
                    background: #fef0f0;
                    color: #f56c6c;
                  }
                }
              }
            }
            
            .invoice-details {
              .error-message {
                font-size: 12px;
                color: #f56c6c;
                margin: 0 0 8px 0;
              }
              
              .invoice-amounts {
                font-size: 12px;
                line-height: 17px;
              }
              
              .invoice-amounts > span {
                display: flex;
                justify-content: space-between;
                margin-bottom: 5px;
              }
              
              .invoice-amounts > span:last-child {
                margin-bottom: 0;
              }
              
              .invoice-amounts .label {
                color: #909599;
              }
              
              .invoice-amounts .value {
                font-weight: bold;
                color: #333333;
              }
              
              .invoice-toggle {
                text-align: center;
              }
             
              .invoice-detail-info {
                margin-top: 15px;
                padding: 15px;
                background-color: #f9f9f9;
              }
              
              .detail-row {
                display: flex;
                flex-wrap: wrap;
              }
              
              .detail-item {
                flex: 1;
                min-width: 200px;
                margin-right: 15px;
              }
              
              .detail-label {
                font-size: 12px;
                color: #909399;
                margin-right: 8px;
              }
              
              .detail-value {
                font-size: 12px;
                color: #303133;
              }
              
              .detail-row:last-child {
                margin-bottom: 0;
              }
            }
          }
          
          .invoice-actions {
            .delete-button {
              padding: 0;
              font-size: 15px;
            }
          }
        }
        
        .invoice-item:last-child {
          margin-bottom: 0;
        }
      }
      
      .upload-tip {
        color: #909399;
        font-size: 12px;
        margin-top: 15px;
      }
    }
    
    .account-section {
      .account-list {
        margin-top: 10px;
        .account-item {
          padding: 8px 0;
          border-bottom: 1px solid #ebeef5;
        }
      }
    }
  }
  
  .page-footer {
    display: flex;
    justify-content: center;
    gap: 15px;
  }
}
</style>